import { render, staticRenderFns } from "./PasswordSetting.vue?vue&type=template&id=0c2e3c57&scoped=true&"
import script from "./PasswordSetting.vue?vue&type=script&lang=js&"
export * from "./PasswordSetting.vue?vue&type=script&lang=js&"
import style0 from "./PasswordSetting.vue?vue&type=style&index=0&id=0c2e3c57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2e3c57",
  null
  
)

export default component.exports